var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsportivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50065 18.6666L4.33398 17.4999L12.334 9.49992H10.1673V11.1666H8.50065V7.83325H13.3548C13.577 7.83325 13.7923 7.87492 14.0007 7.95825C14.209 8.04159 14.3895 8.15964 14.5423 8.31242L17.0423 10.7916C17.4173 11.1666 17.8757 11.4583 18.4173 11.6666C18.959 11.8749 19.5423 11.986 20.1673 11.9999V13.6666C19.3062 13.6666 18.525 13.5346 17.8236 13.2708C17.1222 13.0069 16.5007 12.611 15.959 12.0833L15.1257 11.2083L13.2923 13.0416L15.1673 14.9166L9.70898 18.0624L8.87565 16.6249L12.459 14.5624L11.0423 13.1458L5.50065 18.6666ZM3.50065 12.8333V11.1666H7.66732V12.8333H3.50065ZM1.83398 10.3333V8.66659H6.00065V10.3333H1.83398ZM17.2298 8.66659C16.7715 8.66659 16.3757 8.50339 16.0423 8.177C15.709 7.85061 15.5423 7.45825 15.5423 6.99992C15.5423 6.54159 15.709 6.14922 16.0423 5.82284C16.3757 5.49645 16.7715 5.33325 17.2298 5.33325C17.6882 5.33325 18.084 5.49645 18.4173 5.82284C18.7507 6.14922 18.9173 6.54159 18.9173 6.99992C18.9173 7.45825 18.7507 7.85061 18.4173 8.177C18.084 8.50339 17.6882 8.66659 17.2298 8.66659ZM3.50065 7.83325V6.16659H7.66732V7.83325H3.50065Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsportivo);
export default __webpack_public_path__ + "static/media/esportivo.80541f0606fe1f609af1f196351aa361.svg";
export { ForwardRef as ReactComponent };